// all fields for shortened new submission form
import { ACCOUNT_FIELDS, APPLICATION_FIELDS, CONTACT_FIELDS } from './serverFieldMappings';
import loanUseValues from './loanUseValues';

export default {
  section1: [
    {display: '', inputType: 'title', required: false, useMask: false, placeHolder: ''},
    {modelVal: ACCOUNT_FIELDS.NAME_1, display:'Business DBA', inputType: 'text', required: true, useMask: false, placeHolder: '', maxLength: 80},
    {modelVal: `owners[0].${CONTACT_FIELDS.NAME_1}`, display:'Owner 1 First Name', inputType: 'text', required: true, useMask: false, placeHolder: '', maxLength: 80},
    {modelVal: `owners[0].${CONTACT_FIELDS.NAME_2}`, display: 'Owner 1 Last Name', inputType: 'text', required: true, useMask: false, placeHolder: '', maxLength: 80 },
    {modelVal: APPLICATION_FIELDS.LOAN_USE, display:'Use and Impact of Funds', inputType: 'dropdown', options: loanUseValues, required: false, useMask: false, placeHolder: ''},
    {modelVal: APPLICATION_FIELDS.NOTES, display: 'Notes For Underwriter', inputType: 'textarea', required: false, useMask: false, placeHolder: 'Include any information here that would help the underwriter review the file and give the most competitive approval.'},
    {modelVal: 'uploadDocuments', display: 'Upload Documents', inputType: 'file', required: true},
  ]
};
